// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","app_wrapper":"App_app_wrapper__qEX+N"};